import React, { useContext } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import {
  AwsInstanceAction,
  AwsInstanceRecord,
} from '@totem/components/administration/amazonWebServices/types';
import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';

type Props = {
  instance: AwsInstanceRecord;
};

const menuItems: MenuProps['items'] = [
  { key: 'hierarchy', label: 'Assign Hierarchy' },
  { key: 'salesOrder', label: 'Assign Sales Order' },
  { key: 'device', label: 'Assign Device' },
  { key: 'status', label: 'Update Status' },
  { type: 'divider' },
  { key: 'delete', label: 'Delete', danger: true },
];

// Sales orders on an instance with a device assigned are kept in sync with
// that device by device-sync-service, so manual assignment is hidden.
const hasDevice = (instance: AwsInstanceRecord) =>
  Boolean(instance.item.device?.id) && instance.item.device.id !== EMPTY_ID;

const AwsInstanceActionMenu = ({ instance }: Props) => {
  const { onAction } = useContext(AmazonWebServicesContext);
  const items = hasDevice(instance)
    ? menuItems.filter((item) => item?.key !== 'salesOrder')
    : menuItems;

  const onMenuClicked: MenuProps['onClick'] = ({ key }) => {
    onAction(key as AwsInstanceAction, instance);
  };

  return (
    <Dropdown menu={{ items, onClick: onMenuClicked }} trigger={['click']}>
      <Button size="small" shape="circle" icon={<EllipsisOutlined />} />
    </Dropdown>
  );
};

export default AwsInstanceActionMenu;
